import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCard from 'eco-design/sections/eco-section-card';
import styles from './index.module.scss';

export default function Comp() {
    const { t } = useLang('theProduct.SectionA4');

    return (
        <div className={styles.comp}>
            <EcoSpace />
            <EcoSectionCard
                theme="black"
                layout="center-left"
                title={t('title')}
                lHref="https://jp.ecoflow.com/products/delta-2-max-portable-power-station?variant=51874622931311"
                lChildren={t('btn')}
                lRadius="ellipse"
                pc="https://websiteoss.ecoflow.com/upload/image/1744100215484/charger_section7.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1744100215646/charger_section7_h5.jpg"
                lDataLayer={{
                    event: 'uaEvent',
                    event_name: 'buy',
                    product_name: 'DELTA 2 Max + 800W Alternator Charger',
                    position: `Product Preview`,
                }}
            />
            <EcoSpace />
        </div>
    );
}
